module.exports = __webpack_public_path__ + "img/logo.5091c58e.png";